import { Box, Typography } from '@mui/material'
import LinearProgress from '@mui/material/LinearProgress'

const LinearProgressWithLabel = ({
  percentage,
  customStyle,
  label,
}) => (
  <Box sx={[styles.root, customStyle]}>
    <LinearProgress
      variant="determinate"
      value={Math.min(percentage, 100) || '0'}
      sx={styles.progress}
    />
    <Box sx={styles.labelContainer}>
      <Typography component="p" sx={[styles.progressText, { color: Math.min(percentage, 100) <= 55 ? '#000' : '#FFF' }]}>
        {label}
      </Typography>
    </Box>
  </Box>
)

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    width: '100%',
    gap: '5px',
    flex: 1,
  },
  progress: {
    height: { xs: '20px', sm: '25px' },
    borderRadius: '15px',
    backgroundColor: '#E2E8EE',
    flex: 1,
    '& span': {
      borderRadius: '15px',
    },
  },
  labelContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  progressText: {
    fontSize: { xs: '14px', sm: '16px' },
    width: 'max-content',
    whiteSpace: 'nowrap',
  },
}

export default LinearProgressWithLabel
